// extracted by mini-css-extract-plugin
module.exports = {"container":"Login_container__1Oz4Y","card":"Login_card__2ebUg"};